import { render } from "./root-component.vue?vue&type=template&id=0e8f51cc&ts=true"
import script from "./root-component.ts?vue&type=script&lang=ts"
export * from "./root-component.ts?vue&type=script&lang=ts"

import "./root-component.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__